import React from 'react';
import MapComponent from './components/MapComponent';
import './App.css';
import 'leaflet/dist/leaflet.css';

function App() {
  return (
    <div className="App">
      <MapComponent />
      {/* other components */}
    </div>
  );
}

export default App;
